module.exports = __webpack_public_path__ + "static/img/picture18.a724036b.png";